import React from 'react';

import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import { faWalking } from '@fortawesome/free-solid-svg-icons';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { useTranslation } from 'react-i18next';

import { FontAwesomeSvgIcon } from './FontAwesomeSvgIcon';
import { calculateLengthByType, getDurations, getIconTransport } from '../utils/utils';

export const PathDetails = ({data}) => {

  const {t} = useTranslation();

  const styles = {
    container : {
      display: 'flex',
      width: '100%',
      flexFlow: 'row wrap',
    },
    icon: {
      fontSize: '1.2em'
    },
    chipWalking: {
      padding: '.5em',
      backgroundColor: '#FFFFFF',
      minWidth: '6em'
    }
  };
  let path = [];
  const {features} = data;
  if (features && features.length > 0) {
    features.forEach(elem => {
      if (elem.properties.m === 'transit') {
        path.push({
          typeTransport: elem.properties.t,
          length: elem.properties.length,
          time: elem.properties.time,
          numberLine: elem.properties.transit_info.short_name,
          colorLine: elem.properties.transit_info.color,
          textColorLine: elem.properties.transit_info.text_color,
          mode: elem.properties.m
        });
      } else {
        path.push({
          length: elem.properties.length,
          time: elem.properties.time,
          mode: elem.properties.m
        });
      }
    });
  }

  const pathResults = calculateLengthByType(path);



  const renderChipPath = (elem) => {
    if (elem) {
      if (elem.mode === 'transit') {
        const {numberLine, colorLine, textColorLine, typeTransport} = elem;
        return (
          <Chip 
            sx={{
              ...styles.chipWalking, 
              color: textColorLine?? '#ffffff',
              backgroundColor: colorLine ?? '#000000'
            }} 
            size='small'
            icon={
              <FontAwesomeSvgIcon 
                sx={{
                  ...styles.icon, 
                  fill: textColorLine ?? '#ffffff'
                }} 
                icon={getIconTransport(typeTransport)} 
              />}
            label={numberLine ?? t('transportDetails.label-unknown')}
          />
        );
      } else {
        return(
          <Chip sx={styles.chipWalking} 
            icon={<FontAwesomeSvgIcon sx={styles.icon} icon={faWalking} />}
            size='small'
            label={getDurations(elem.time)}
          />
 
        );
      }
      
    } else {
      return (
        <Chip sx={styles.chipWalking} 
          icon={<FontAwesomeSvgIcon sx={styles.icon} icon={faWalking} />}
          size='small'
          label={t('transportDetails.label-unknown')}
        />
      );
    }
    
  };

  return (
    <Grid container sx={styles.container}>
      {pathResults.map((elem, index) => {
        return (
          <Grid key={index} xs={4} item sx={{display: 'flex', paddingY: '.2em', alignItems: 'center', justifyContent: 'space-between', flexGrow: 1}}>
            {renderChipPath(elem)}
            {index !== pathResults.length - 1 && (
              <Box sx={{display: 'flex', alignItems: 'center'}}>
                <ArrowRightIcon />
              </Box>
            )}
          </Grid>
        );
      })}
    </Grid>
  );
};